import { render, staticRenderFns } from "./mstrbudgetaddition.vue?vue&type=template&id=7bb8a8d1"
import script from "./mstrbudgetaddition.vue?vue&type=script&lang=js"
export * from "./mstrbudgetaddition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports